import { render, staticRenderFns } from "./LogRecord.vue?vue&type=template&id=0dd41f56&scoped=true&"
import script from "./LogRecord.vue?vue&type=script&lang=js&"
export * from "./LogRecord.vue?vue&type=script&lang=js&"
import style0 from "./LogRecord.vue?vue&type=style&index=0&id=0dd41f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd41f56",
  null
  
)

export default component.exports